import { Snowflake, Zap, Droplets, DoorOpen, Hammer, HelpCircle, Refrigerator, AppWindow, Gauge, House, PaintRoller, BrickWall,
  Flame, Sun, Cctv, Tv, Bug, Sparkles, Sprout, Waves, Wrench } from "lucide-react";

export const IMG = {
  hero: "/img/hero.jpg",
  electrician: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  ac: "https://images.pexels.com/photos/5463575/pexels-photo-5463575.jpeg?auto=compress&cs=tinysrgb&w=1000",
  handyman: "https://images.pexels.com/photos/17063686/pexels-photo-17063686.jpeg?auto=compress&cs=tinysrgb&w=1000",
  pro: "/img/join-pros.jpg",
};

export const SERVICES = [
  { key: "ac", icon: Snowflake },
  { key: "electrical", icon: Zap },
  { key: "plumbing", icon: Droplets },
  { key: "doors", icon: DoorOpen },
  { key: "windows", icon: AppWindow },
  { key: "appliances", icon: Refrigerator },
  { key: "water_pumps", icon: Gauge },
  { key: "roofing", icon: House },
  { key: "painting", icon: PaintRoller },
  { key: "carpentry", icon: Hammer },
  { key: "masonry", icon: BrickWall },
  { key: "welding", icon: Flame },
  { key: "solar", icon: Sun },
  { key: "security", icon: Cctv },
  { key: "mounting", icon: Tv },
  { key: "pest", icon: Bug },
  { key: "cleaning", icon: Sparkles },
  { key: "gardening", icon: Sprout },
  { key: "pool", icon: Waves },
  { key: "general", icon: Wrench },
  { key: "other", icon: HelpCircle },
];

export const STATUSES = ["new", "needs_review", "contacting_customer", "ready_to_assign", "assigned", "estimate_pending",
  "estimate_sent", "approved", "scheduled", "in_progress", "completed", "closed",
  "unable_to_serve", "customer_canceled", "disputed", "emergency_referral"];

const TONES = {
  new: "bg-sky-100 text-sky-800", needs_review: "bg-amber-100 text-amber-800", contacting_customer: "bg-amber-100 text-amber-800",
  ready_to_assign: "bg-indigo-100 text-indigo-800", assigned: "bg-teal-100 text-teal-800", estimate_pending: "bg-orange-100 text-orange-800",
  estimate_sent: "bg-orange-100 text-orange-800", approved: "bg-emerald-100 text-emerald-800", scheduled: "bg-teal-100 text-teal-800",
  in_progress: "bg-cyan-100 text-cyan-800", completed: "bg-emerald-100 text-emerald-800", closed: "bg-slate-200 text-slate-700",
  unable_to_serve: "bg-slate-200 text-slate-700", customer_canceled: "bg-slate-200 text-slate-700", disputed: "bg-red-100 text-red-800",
  emergency_referral: "bg-red-600 text-white",
};
export const tone = (s) => TONES[s] || "bg-slate-100 text-slate-700";

export const UPDATE_TEMPLATES = [
  { title: "We received your request", body: "Thanks for contacting NicaFix. We're reviewing your request and will contact you with the next step.", status: "needs_review", from: ["new"] },
  { title: "We need a bit more information", body: "To help you properly, please reply with more details or photos of the issue.", status: "contacting_customer", from: ["new", "needs_review", "ready_to_assign"] },
  { title: "A professional has been assigned", body: "A NicaFix professional has been assigned to your request. They will propose visit times soon.", status: "" },
  { title: "Your visit is scheduled", body: "Your visit has been scheduled. Please make sure someone can provide access to the home.", status: "scheduled", from: ["approved"] },
  { title: "We can't serve this request right now", body: "We're sorry — we don't have an available professional for this job in your area right now.", status: "unable_to_serve" },
  { title: "Please contact emergency services", body: "Your request describes an immediate hazard. Please leave the area and call 911 now. NicaFix will follow up once it's safe.", status: "emergency_referral" },
];
